module.exports = __webpack_public_path__ + "static/media/iconAdopt-final.c33058b4.svg";